import "./about.css";
import { Row, Col } from "react-bootstrap";
import Heading from "../../heading/Heading";

const About = () => {
  return (
    <div className="about" id="about">
      <Heading word="About" headingSize="h1" />
      <Row>
        <Col
          lg={8}
          md={9}
          sm={12}
          className="d-flex flex-column align-items-md-start align-items-sm-center align-items-center"
        >
          <Heading word="Me Myself And I" headingSize="h3" />
          <p>
            I'm a <strong>Web Developer</strong> on a goal to make user
            experiences as smooth as possible. Beginning with a strong
            foundation in front-end basics and <strong>React.js</strong>, I've
            moved on to back-end programming using <strong>ASP.NET Core</strong>
            . My interest is transforming ideas into attractive, effective apps.
            I contribute a unique combination of creativity and expertise to
            every project as part of my dedication to being at the top of
            technology.
          </p>
        </Col>
        <Col
          lg={4}
          md={3}
          sm={12}
          className="d-flex flex-column align-items-md-start align-items-sm-center align-items-center"
        >
          <Heading word="Bio" headingSize="h3" />
          <ul>
            <li>
              <strong>Address</strong>: Tbilisi, Georgia
            </li>
            <li>
              <strong>Email</strong>: gogelianika1@gmail.com
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );
};

export default About;
